import { PRIMENG_EN_US } from './primeng-en-us';
import { PRIMENG_ES_ES } from './primeng-es-es';
import { PRIMENG_PT_BR } from './primeng-pt-br';

export const PRIMENG_TRANSLATIONS = {
  pt: PRIMENG_PT_BR,
  en: PRIMENG_EN_US,
  es: PRIMENG_ES_ES,
};

export { PRIMENG_EN_US, PRIMENG_ES_ES, PRIMENG_PT_BR };
